import { default as indexnCmJ7TEc38Meta } from "/home/forge/amosweb.de/releases/20250506200506/newsletters/pages/index.vue?macro=true";
import { default as newsletterIFramegck3Dx4eKRMeta } from "/home/forge/amosweb.de/releases/20250506200506/newsletters/pages/newsletterIFrame.vue?macro=true";
import { default as _91id_93QicoOZ7tpcMeta } from "/home/forge/amosweb.de/releases/20250506200506/newsletters/pages/show/[id].vue?macro=true";
import { default as showaPd2QU9WRlMeta } from "/home/forge/amosweb.de/releases/20250506200506/newsletters/pages/show.vue?macro=true";
import { default as _91id_938jO31esDpdMeta } from "/home/forge/amosweb.de/releases/20250506200506/newsletters/pages/subscribe/[id].vue?macro=true";
import { default as subscribe62dUyqd6p8Meta } from "/home/forge/amosweb.de/releases/20250506200506/newsletters/pages/subscribe.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/forge/amosweb.de/releases/20250506200506/newsletters/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "newsletterIFrame",
    path: "/newsletterIFrame",
    component: () => import("/home/forge/amosweb.de/releases/20250506200506/newsletters/pages/newsletterIFrame.vue").then(m => m.default || m)
  },
  {
    name: "show",
    path: "/show",
    component: () => import("/home/forge/amosweb.de/releases/20250506200506/newsletters/pages/show.vue").then(m => m.default || m),
    children: [
  {
    name: "show-id",
    path: ":id()",
    component: () => import("/home/forge/amosweb.de/releases/20250506200506/newsletters/pages/show/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "subscribe",
    path: "/subscribe",
    component: () => import("/home/forge/amosweb.de/releases/20250506200506/newsletters/pages/subscribe.vue").then(m => m.default || m),
    children: [
  {
    name: "subscribe-id",
    path: ":id()",
    component: () => import("/home/forge/amosweb.de/releases/20250506200506/newsletters/pages/subscribe/[id].vue").then(m => m.default || m)
  }
]
  }
]